import { Alert } from '@side/pantry';

export function ClonedTransactionAlert() {
  return (
    <Alert square severity="warning" variant="stacked">
      This is a cloned transaction. Please review the information before
      proceeding.
    </Alert>
  );
}
